import { SkeletonText, StackLayout, Box } from '@leagueplatform/genesis-core';

export const RedirectSkeleton = () => (
  <StackLayout
    orientation="vertical"
    horizontalAlignment="center"
    verticalAlignment="center"
    css={{
      height: '100vh',
      width: '100%',
      textAlign: 'center',
    }}
  >
    {/* Redirect Message */}
    <Box css={{ marginBottom: '$two' }}>
      <SkeletonText header width={250} css={{ marginBottom: '$one' }} />
      <SkeletonText lines={1} />
    </Box>

    {/* Loading Indicator */}
    <Box
      css={{
        width: '40px',
        height: '40px',
        backgroundColor: '$surfaceBackgroundSecondary',
        borderRadius: '$full',
      }}
    />
  </StackLayout>
);
